export default __webpack_public_path__ + "static/media/not-applicable.761132e8.svg";